/**
 * Constants for inbox functionality
 */

/**
 * Maximum number of transactions to fetch in a single request
 */
export const TRANSACTION_FETCH_LIMIT = 100;

/**
 * Minimum number of items before disabling pagination
 * Note: V2 API returns all contacts, so pagination is effectively disabled
 */
export const PAGINATION_THRESHOLD = 10;

/**
 * Maximum height for the inbox items list (in pixels)
 */
export const INBOX_MAX_HEIGHT = 600;
